import {
  collection,
  type CollectionReference,
  type DocumentData,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { ZodError } from 'zod'
import type { FirestoreProduct } from './schema'
import { schema } from './schema'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import type { StreamInterface } from 'tricklejs/dist/types'
import { modelListStream } from '../../firestore-mobx/stream'
import { Product } from '../../models/Product'

export * from './schema'

const converter: FirestoreDataConverter<FirestoreProduct> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    try {
      return schema.parse(data)
    } catch (e) {
      if (e instanceof ZodError) {
        console.error('Error parsing product', e.errors)
      }
      throw e
    }
  },
}

const getColRef = (
  firestore: Firestore
): CollectionReference<FirestoreProduct, DocumentData> => {
  return collection(firestore, 'product').withConverter(converter)
}

export const getProducts = (
  repository: FirebaseRepository
): StreamInterface<Product[]> => {
  const ref = getColRef(repository.firestore)

  return modelListStream(repository, ref, Product)
}
